import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { environment } from '@env/environment';

import { LoginInterceptor } from './login.interceptor';

import { API_BASE_URL } from './index';

@NgModule({
  imports: [CommonModule],
  declarations: [],
  providers: [
    {
      provide: API_BASE_URL,
      useValue: environment.api.brasilprev.url + '/login-bff'
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoginInterceptor,
      multi: true
    }
  ],
  exports: []
})
export class LoginModule {}
